import { ALL_NAV_ITEMS } from "../config/dashboardNav";
import { OPS_PERMISSIONS, userHasPermission } from "../config/permissions";

/**
 * Landing path after login / guest redirect.
 * Prefer Ops Overview when the user has dashboard.view; otherwise first allowed nav item.
 */
export function getOpsHomePath(user) {
  if (userHasPermission(user, OPS_PERMISSIONS.DASHBOARD_VIEW)) {
    return "/dashboard";
  }

  const firstAllowed = ALL_NAV_ITEMS.find((item) => {
    if (!item.permissions?.length) return true;
    return item.permissions.some((permission) => userHasPermission(user, permission));
  });

  return firstAllowed?.path ?? "/dashboard";
}
